import { Button, DatePicker, Space, message } from 'antd'
import moment from 'moment'

import React from 'react'
import {
    createAddDateHandler,
    createRemoveDateHandler,
    createUpdateDateHandler,
    isDateDisabled,
} from '../../utils/helper'

interface MultipleDatePickerProps {
    value?: moment.Moment[]
    onChange?: (val: moment.Moment[]) => void
    maxDates?: number
}

const MultipleDatePicker: React.FC<MultipleDatePickerProps> = ({
    value = [],
    onChange,
    maxDates,
}) => {
    const addDate = () => {
        const result = createAddDateHandler(value, onChange, maxDates)()
        if ('error' in result) {
            message.warning(result.error)
        }
    }

    const removeDate = createRemoveDateHandler(value, onChange)
    const updateDate = createUpdateDateHandler(value, onChange)

    return (
        <div>
            <div style={{ marginBottom: 8 }}>
                <Button
                    onClick={addDate}
                    size='small'
                    type='dashed'
                    disabled={!!(maxDates && value.length >= maxDates)}
                >
                    + Add Date {maxDates ? `(${value.length}/${maxDates})` : ''}
                </Button>
            </div>
            <Space direction='vertical' style={{ width: '100%' }}>
                {value.map((date, index) => (
                    <div key={index} style={{ display: 'flex', gap: 8 }}>
                        <DatePicker
                            value={date}
                            onChange={d => updateDate(index, d)}
                            allowClear={false}
                            disabledDate={isDateDisabled}
                        />
                        <Button danger size='small' onClick={() => removeDate(index)}>
                            X
                        </Button>
                    </div>
                ))}
            </Space>
        </div>
    )
}

export default MultipleDatePicker
